import React from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import {Typography, Paper, Button} from '@mui/material'
import Home from '@mui/icons-material/Home'

const PREFIX = 'Page404';

const classes = {
  icon: `${PREFIX}-icon`,
  container: `${PREFIX}-container`,
  paper: `${PREFIX}-paper`,
  button: `${PREFIX}-button`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.icon}`]: {
    width: 400,
    height: 400,
    color: theme.palette.secondary.main,
  },

  [`& .${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: `100%`,
  },

  [`& .${classes.paper}`]: {
    backgroundColor: theme.palette.background.default,
    margin: 0,
    height: `calc(100vh - 64px)`,
  },

  [`& .${classes.button}`]: {
    marginTop: 20,
  }
}));

const Page404 = () => {
  const history = useHistory();


  const currentError = history?.location?.state;

  return (
    <Root>
        <Paper className={classes.paper}>
          <div className={classes.container}>
            <Typography variant="h4">Page Not Found</Typography>
            <Typography variant="subtitle1">
              <img  className={classes.icon} src="/icons/404.svg" alt="Page Not Found"></img>
            </Typography>
            {currentError?.body && <Typography variant="subtitle1">
              {currentError.body}
            </Typography>}
            <Button
              color="secondary"
              aria-label="home"
              href="/"
              className={classes.button}
            >
              <Home />
            </Button>
          </div>
        </Paper>

    
    </Root>
  );
}

export default Page404;
